import type { PlanSegment } from '@features/pricing';

/**
 * Maps the agency `type` field from the backend to the corresponding
 * plan segment used by `usePlans`.
 *
 * Defaults to `'agency'` for unknown or missing values so the component
 * is always in a valid, non-empty state.
 */
export function agencyTypeToSegment(type?: string): PlanSegment {
  return type === 'solo_broker' ? 'solo' : 'agency';
}
